export default "__VITE_PUBLIC_ASSET__90ac3d9c__"